/**
 * Define marketing parameters for mini-generators page
 */
export const marketingParams = {
  sourceType: 'Pull',
  simulationSo: 'Mini-opwekkers'
}
